import NightButton from './buttons/NightButton'
import { t } from '../../../utilities/translator'
import { selectDateFilter } from '../../mainFilter/selectors'
import { useAppSelector } from '../../../hooks/hooks'
import Checkbox from './form/Checkbox'

interface NightsListProps {
  selected: number[];
  onChange: (value: number) => void;
  weekendsOnly: boolean;
  onWeekendsChange: (value: boolean) => void;
  showWeekendsOnly?: boolean;
  daysInterval?: number;
  variant?: 'gray' | 'white';
}

const NightsList = ({
  selected,
  onChange,
  weekendsOnly,
  onWeekendsChange,
  showWeekendsOnly = true,
  daysInterval,
  variant = 'white',
}: NightsListProps) => {
  const datesFilter = useAppSelector(selectDateFilter);

  const onDayClick = (value: number) => {
    if ((daysInterval && daysInterval >= value) || !daysInterval) {
      onChange(value)
    }
  }

  return (
    <>
      <div>
        <p className="days-list-title mb-5 label-large text-start font-semibold">{t('mainFilter.number_of_nights')}</p>
        <div className="move-days-list">
          {datesFilter.initial.nightsList.map(({ value }: { value: number }) => (
            <NightButton
              key={value}
              value={value}
              selected={selected.includes(value)}
              onClick={() => onDayClick(value)}
              notActive={daysInterval && daysInterval < value}
              variant={variant}
            />
          ))}
        </div>
      </div>

      {showWeekendsOnly && (
        <>
          <Checkbox
            label={t('mainFilter.weekends_only')}
            checked={weekendsOnly}
            onChange={() => onWeekendsChange(!weekendsOnly)}
          />
        </>
      )}
    </>
  )
}

export default NightsList
